"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { spacing } from "../../../../core/design-system/index.js";
import { Container } from "../../components/basic.js";
import { Link } from "../../components/text.js";
import { Text } from "../../components/text.js";
/**
 * @internal
 */
export function TOS(props) {
    const { termsOfServiceUrl, privacyPolicyUrl, locale, requireApproval } = props;
    if (!termsOfServiceUrl && !privacyPolicyUrl && !requireApproval) {
        return null;
    }
    const bothGiven = termsOfServiceUrl && privacyPolicyUrl;
    return (_jsx(Container, { flex: "row", center: "x", children: _jsxs(Text, { size: "xs", multiline: true, balance: true, inline: true, center: true, style: {
                maxWidth: "250px",
            }, children: [requireApproval && (_jsx("input", { style: {
                        transform: "translateY(3px)",
                        marginRight: spacing["3xs"],
                    }, type: "checkbox", onChange: props.onApprove, checked: props.isApproved, disabled: !requireApproval })), locale.prefix, " ", termsOfServiceUrl && (_jsxs(Link, { inline: true, size: "xs", href: termsOfServiceUrl, target: "_blank", style: {
                        whiteSpace: "nowrap",
                    }, children: [" ", locale.termsOfService, " "] })), bothGiven && `${locale.and} `, privacyPolicyUrl && (_jsx(Link, { inline: true, size: "xs", href: privacyPolicyUrl, target: "_blank", children: locale.privacyPolicy })), !privacyPolicyUrl && !termsOfServiceUrl && (_jsx(Text, { inline: true, size: "xs", children: "Terms of Service and Privacy Policy" }))] }) }));
}
//# sourceMappingURL=TOS.js.map